import { createFileRoute, redirect } from '@tanstack/react-router'

import type { EmailSection } from '@/components/settings/email-sidebar'

export const Route = createFileRoute('/_app/_settings/email-suppressions')({
  beforeLoad: () => {
    throw redirect({
      to: '/email',
      search: { section: 'blocked-recipients' as EmailSection },
    })
  },
})
